<template>
  <v-card flat class="pa-5">
 
    <!-- Select asset transaction date -->
    <v-menu
      :close-on-content-click="false"
      v-model="assetdatepicker"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    > 
      <v-text-field
        slot="activator"
        v-model="assetInvoiceDate"
        label="Date"
        prepend-icon="event"
        readonly
      ></v-text-field>
      <v-date-picker v-model="assetInvoiceDate" @input="assetdatepicker = false" />
    </v-menu>

    <!-- All asset transaction done on firm -->
    <v-select
      v-model="selectedFirmFromAsset"
      :items="firmsByBrand"
      label="To Firm"
      return-object
      required
    >
        <template slot="selection" slot-scope="data">
            {{ data.item.text }}
        </template>
        <template slot="item" slot-scope="data">
            <v-list-tile-content>
                <v-list-tile-title v-html="`${data.item.firm.name}${data.item.firm.proprietor ? ' | '+data.item.firm.proprietor : '' } | ₹: ${(data.item.firm.amount || 0).toLocaleString()}`" />
            </v-list-tile-content>
        </template>
    </v-select>

    <v-autocomplete
      v-bind:items="assetByBrand"
      v-model="selectAsset"
      label="Select or add Asset"
      @keyup.native.enter="addAsset"
    />
    <span class="error--text" v-if="addError">{{addError}}</span>

    <template v-if="selectedAssetDetail">

    <!-- asset category -->
    <v-select
        :disabled="assetEditDisabled"
        v-model="asset.category"
        :items="assetCategoryList"
        label="Asset Category"
        required
    />
    <!-- asset type -->
    <v-select
        :disabled="assetEditDisabled"
        v-if="asset.category"
        v-model="asset.type"
        :items="assetTypeList"
        label="Asset Type"
        required
    />
    <!-- asset Allocate depriciating % based on selected type -->
    <v-select
        :disabled="assetEditDisabled"
        v-if="asset.type && allowDepriciation"
        label="Allocate Depriciation % ?"
        v-model="asset.depriciation"
        :items="depriciationList"
    />

    <!-- Start of New Development / GST -->    
    <div v-if="selectAsset">
        <b class="subheading primary--text font-weight-bold"> IS GST Applicable Over this Asset? </b> 
    </div>

    <v-radio-group 
        v-model="isGSTApplicable" 
        row 
        v-if="selectAsset">
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
    </v-radio-group>

    <v-select
        dense
        :items="[0,5,12,18,28]"
        v-model="taxableGST_rate"
        v-if="isGSTApplicable && selectAsset"
        label="Taxable GST rate"
    ></v-select>

    <v-select
        dense
        v-if="isGSTApplicable && selectAsset"
        :items="GST_types_list"
        label="Select GST type"
        v-model="GST_type"
    ></v-select>

    <!-- <div v-if="isGSTApplicable && selectExpense">
        <b class="subheading primary--text font-weight-bold">Does RCM Applicable ? </b> 
    </div>

    <v-radio-group 
        v-model="isRCMApplicable" 
        row 
        v-if="isGSTApplicable && selectExpense">
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
    </v-radio-group> -->

    <!-- End  of  New Development / GST --> 


    <!-- Asset Age -->
    <v-radio-group
        :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
        v-if="asset.type"
        v-model="asset.age"
        label="Asset Age"
    >
        <v-radio 
            label="New" 
            :value="true">
            <template v-slot:label>
                <div>
                    <strong class="success--text">
                        NEW
                    </strong>
                    <b class="font-weight-light">Recently Purchased</b>
                </div>
            </template>
        </v-radio>

        <v-radio 
            label="old" 
            :value="false">
            <template v-slot:label>
                <div>
                    <strong class="primary--text">
                        OLD
                    </strong>
                    <b class="font-weight-light">Already Have</b>
                </div>
            </template>
        </v-radio>
    </v-radio-group>

    <template v-if="asset.age === true">
        
        <!-- Basic Value -->
        <v-text-field 
            label="Taxable Value"  
            type="number"
            v-model="taxableAmount" 
            @keyup="$set(asset, 'totalAmount', (Number.parseFloat(taxableAmount) + Number.parseFloat((taxableAmount*taxableGST_rate)/100)));"
            v-if="selectAsset && isGSTApplicable && !isOpeningBalance"
        >
        </v-text-field>

        <!-- GST Value -->   
        <v-text-field 
            label="GST Value" 
            :value="((taxableAmount*taxableGST_rate)/100)" 
            v-if="selectAsset && isGSTApplicable && !isOpeningBalance"
            :disabled="true"
        >
        </v-text-field>


        <!-- asset total Amount -->
        <v-text-field 
            :disabled="assetEditDisabled && !!selectedFirmOpeningBalance" 
            v-if="asset.type && asset.age"
            label="Total Amount of Asset" 
            type="number" 
            :hint="hintText"
            v-model="asset.totalAmount" />
    
        <!-- asset Purchase Type -->
        <v-select
            :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
            v-if="asset.type && asset.age"
            v-model="asset.purchaseType"
            label="Asset Purchase Type"
            @change="delete asset.paymentType"
            :items="assetPurchaseType"
        />

        <!-- if Downpayment -->
        <!-- asset downpayment amount -->
        <template v-if="asset.purchaseType && asset.purchaseType === 'downpayment'">
            <!-- <v-text-field
                :disabled="assetEditDisabled"
                type='number'
                label="Downpayment Amount"
                v-model="asset.downPaymentAmount"
                :error-messages="Number(asset.totalAmount) != Number(asset.downPaymentAmount) ? ['Downpayment Amount should be equal to Total Amount'] : []"
            /> -->
            <!-- asset payement type -->
            <v-select
                dense
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                label="Select Payment Type"
                v-model="asset.paymentType"
                :items="paymentOptions"
            />
            <!-- if cash&bank: ask for both value for seperate deduction -->
            <v-text-field 
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                v-if="asset.paymentType === 'CashAndBank Account'"
                v-model="asset.amountFromCash" 
                type="number"
                label="Amount to Pay From Cash"
                :hint="hintText"
                :error-messages="(Number(asset.amountFromCash) + Number(asset.amountFromBank)) != Number(asset.totalAmount) && asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Total Amount'] : []"
            />
            <v-text-field
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                v-if="asset.paymentType === 'CashAndBank Account'"
                v-model="asset.amountFromBank"
                type="number"
                label="Amount to Pay From Bank"
                :hint="hintText"
                :error-messages="(Number(asset.amountFromCash) + Number(asset.amountFromBank)) != Number(asset.totalAmount) && asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Total Amount'] : []"
            />

            <v-select
                v-if="asset.paymentType && asset.paymentType !== 'Cash'"
                v-model="selectAccountFromAsset"
                :items="otherAccountByBrand"
                label="Account to pay from bank"
                required
            >
                <template slot="selection" slot-scope="data">
                    {{ data.item.text }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.text}
                            ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                            ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                            | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                        " />
                    </v-list-tile-content>
                </template>
            </v-select>
        </template>
        
        <!-- if partial -->
        <template v-if="asset.purchaseType && asset.purchaseType === 'partial'">
            <!-- asset downpayment amount -->
            <v-text-field
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                type="number"
                label="Downpayment Amount"
                v-model="asset.downPaymentAmount"
                :hint="downPaymentHintText"
                :error-messages="Number(asset.totalAmount) != Number(asset.downPaymentAmount) + Number(asset.installmentAmount) ? ['Downpayment, Installlment Amount total should be equal to Total Amount'] : []"
            />
            <!-- asset payement type -->
            <v-select
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                dense
                label="Select Payment Type"
                v-model="asset.paymentType"
                :items="paymentOptions"
            />
            <!-- if cash&bank: ask for both value for seperate deduction -->
            <v-text-field 
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                v-if="asset.paymentType === 'CashAndBank Account'"
                v-model="asset.amountFromCash" 
                type="number"
                :hint="hintText"
                label="Amount to Pay From Cash"
                :error-messages="(Number(asset.amountFromCash) + Number(asset.amountFromBank)) != Number(asset.downPaymentAmount) && asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Downpayment Amount'] : []"
            />
            <v-text-field
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                v-if="asset.paymentType ==='CashAndBank Account'"
                v-model="asset.amountFromBank"
                type="number"
                label="Amount to Pay From Bank"
                :hint="hintText"
                :error-messages="(Number(asset.amountFromCash) + Number(asset.amountFromBank)) != Number(asset.downPaymentAmount) && asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Downpayment Amount'] : []"
            />
            <v-select
                v-if="asset.paymentType && asset.paymentType !== 'Cash'"
                v-model="selectAccountFromAsset"
                :items="otherAccountByBrand"
                label="Account to Pay From Bank"
                required
            >
                <template slot="selection" slot-scope="data">
                    {{ data.item.text }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.text}
                            ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                            ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                            | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                        " />
                    </v-list-tile-content>
                </template>
            </v-select>
            <!-- asset installment amount -->
            <v-text-field
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                label="Installment Amount"
                type="number"
                :hint="installmentHintText"
                v-model="asset.installmentAmount"
                :error-messages="Number(asset.totalAmount) != Number(asset.downPaymentAmount) + Number(asset.installmentAmount) ? ['Downpayment, Installlment Amount total should be equal to Total Amount'] : []"
            />
            <!-- select loan bank account for installment deduction -->
            <v-btn 
                @click="getFirms"
                v-if="loanAccountByBrand.length == 0 || loanAccountByBrand"
                outline
                color="primary">
                <v-icon>
                    add
                </v-icon> 
                &nbsp; New Loan Account [Bank]
            </v-btn>
            <v-select
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                v-model="asset.loanAccount"
                :items="loanAccountByBrand"
                label="Loan Account for installment"
                required
            >
                <template slot="selection" slot-scope="data">
                    {{ data.item.text }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.text}
                            ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                            ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                            | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                        "/>
                    </v-list-tile-content>
                </template>
            </v-select>
        </template>
                
        <!-- if EMI -->
        <template v-if="asset.purchaseType && asset.purchaseType === 'installment'">
            <!-- asset installment amount -->
            <!-- <v-text-field      
                :disabled="assetEditDisabled"      
                label="Installment Amount"
                type="number"
                v-model="asset.installmentAmount"
                :error-messages="Number(asset.totalAmount) != Number(asset.installmentAmount) ? ['Installment Amount should be equal to Total Amount'] : []"
            /> -->
            <!-- select loan bank account for installment deduction -->
            <v-btn 
                @click="getFirms"
                v-if="loanAccountByBrand.length == 0"
                outline
                color="primary">
                <v-icon>
                    add
                </v-icon> 
                &nbsp; New Loan Account [Bank]
            </v-btn>
            <v-select
                :disabled="assetEditDisabled && !!selectedFirmOpeningBalance"
                v-model="asset.loanAccount"
                :items="loanAccountByBrand"
                label="Loan Account for installment"
                required
            >
                <template slot="selection" slot-scope="data">
                    {{ data.item.text }}
                </template>
                <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="`${data.item.text}
                            ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                            ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                            | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                        "/>
                    </v-list-tile-content>
                </template>
            </v-select>
        </template>
    </template>
    <!-- <div v-if="selectAsset && (!firmAsset.length) && !selectedFirmOpeningBalance">Is Opening Balance Available</div>
        <v-radio-group v-model="isOpeningBalance" row v-if="selectAsset && (!firmAsset.length)">
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
        
        <v-text-field 
            type="number"
            v-if="(selectAsset && isOpeningBalance && !firmAsset.length) && !selectedFirmOpeningBalance"
            label="Opening Balance" 
            v-model="asset.openingBalance">
        </v-text-field>

        <v-text-field 
            :disabled="assetEditDisabled" 
            v-if="(selectAsset && !isOpeningBalance)"
            label="Total Amount of Asset" 
            type="number" 
            v-model="asset.totalAmount" /> -->
    <template v-if="asset.age === false">
        <!-- asset opening Balance: default is 0 -->
        <v-text-field
            :disabled="asset.disableOpeningBalance && !!selectedFirmOpeningBalance"
            type="number"
            label="Opening Balance of Asset"
            :hint="hintText" 
            v-model="asset.openingBalance" 
        />

        <!-- Addition or deletion on asset if old -->
        <v-select
            v-if="selectAsset"
            v-model="addition"
            label="Select Operation Type"
            :items="getOperationOptions"
        />
        <v-text-field
            v-if="selectAsset && addition === 'addition'"
            type="number"
            label="Addition Amount"
            v-model="additionAmount"
            :hint="hintText"
        />
        <v-text-field
            type="number"
            v-if="selectAsset && addition === 'deletion'"
            label="Deletion Amount"
            v-model="deletionAmount"
            :hint="hintText"
        />

        <!-- asset payement type -->
        <v-select
            dense
            v-if="additionAmount || deletionAmount"
            label="Select Payment Type"
            v-model="operationPaymentType"
            :items="paymentOptions"
        />
        <!-- if cash&bank: ask for both value for seperate deduction -->
        <v-text-field 
            v-if="operationPaymentType === 'CashAndBank Account'"
            v-model="operationAmountFromCash" 
            type="number"
            label="Operation Amount to Pay From Cash"
            :error-messages="(Number(operationAmountFromCash) + Number(operationAmountFromBank)) != Number(addition === 'addition' ? additionAmount : deletionAmount) && operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []"
        />
        <v-text-field
            v-if="operationPaymentType === 'CashAndBank Account'"
            v-model="operationAmountFromBank"
            type="number"
            label="Operation Amount to Pay From Bank"
            :hint="hintText"
            :error-messages="(Number(operationAmountFromCash) + Number(operationAmountFromBank)) != Number(addition === 'addition' ? additionAmount : deletionAmount) && operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []"
        />
        <v-select
            v-if="operationPaymentType && operationPaymentType !== 'Cash'"
            v-model="operationAccountForTransaction"
            :items="otherAccountByBrand"
            label="Bank Account to Pay operation amount from Bank"
            required
        >
            <template slot="selection" slot-scope="data">
                {{ data.item.text }}
            </template>
            <template slot="item" slot-scope="data">
                <v-list-tile-content>
                    <v-list-tile-title v-html="`${data.item.text}
                        ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                        ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                        | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                    " />
                </v-list-tile-content>
            </template>
        </v-select>
    </template>

    <!-- add asset remark for  invoice/asset add-->
    <v-text-field label="Remark" v-model="assetRemark"></v-text-field>
    </template>

    <v-btn color="primary" @click="assetAmountClick">
      <v-icon right dark>money_off</v-icon>Save
    </v-btn>
    <v-btn color="primary" @click="$router.go(-1)">
      <v-icon left dark>cancel</v-icon>Cancel
    </v-btn>
    <v-btn color="primary" @click="openAssetTable = true">
      View Asset Table
    </v-btn>
    <v-dialog
        fullScreen
        v-model="openAssetTable"
        transition="dialog-bottom-transition"
    >
        <v-toolbar card dark color="primary">
            <v-toolbar-title>Asset Table</v-toolbar-title>
            <v-spacer/>
            <v-btn icon dark @click.native="openAssetTable = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card>
            <asset-table-info />
        </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
      <v-form ref="addAccount" v-model="addNewAccountValid" lazy-validation>
        <v-card-title primary title class="primary white--text">
           <span class="headline">Add New Bank Account</span> 
        </v-card-title>
        <v-card-text>
          <v-select
          :items="firmsByBrand"
          v-model="currentFirm"
          label="Select Firms"
        ></v-select>
          <v-select
          item-text="name"
          item-value="id"
          :items="currentBankName"
          v-model="bankNameForLoan"
          :rules="requiredRule"
          label="Choose Bank"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAccountCategoryForLoan"
          v-model="accountCategoryForLoan"
          @change="categoryChange"
          :rules="requiredRule"
          label="Choose account category"
        ></v-select>
        <v-select
          item-text="name"
          item-value="id"
          :items="currentAccountType"
          v-model="accountTypeForLoan"
          :rules="requiredRule"
          label="Choose Account Type"
        ></v-select>
          <v-text-field label="Account Holder Name" :rules="requiredRule" v-model="accountHolderName" :disabled="accholderdisabled"></v-text-field>
          <v-text-field label="Account Number" :rules="requiredRule" v-model="accountnumberForLoan" ></v-text-field>
          <v-text-field label="IFSC code" :rules="IFSC_Rules" v-model="ifsccode" ></v-text-field>
          <v-text-field label="Location" :rules="requiredRule" v-model="accountLocation" ></v-text-field>
          <v-menu
            :close-on-content-click="false"
            v-model="datepicker1"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="accountOpeningDate"
              label="Opening Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="accountOpeningDate" @input="datepicker1 = false"></v-date-picker>
          </v-menu>
          <v-text-field label="Amount" v-model.number="initialamount" ></v-text-field>
          <!-- <v-text-field label="Opening Balance" v-model="openingBalance" ></v-text-field> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn primary title class="warning white--text" flat="flat" @click="cancelDialog">
            Cancel
          </v-btn>
          <v-btn primary title class="primary white--text" flat="flat" @click="addNewAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>

import {
    ASSET_TYPE_WITH_DEPRICIATION,
    ASSET_CATEGORY,
    ASSET_PURCHASE_TYPE,
    PAYMENT_OPTIONS,
    getFinancialYear
} from './utils';

import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import AssetTableInfo from '../table/assetTable.vue';
import {digitsToWords} from '../../../utils/digitsToWords.js'

export default {
    name: 'AsseetTab',
    props: {
        selectedBrand: { type: String, default: '' },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
        assetByBrand: {type: Array },
    },
    components: {
        AssetTableInfo
    },
    data() {
        return {
             requiredRule: [
                v => !!v || 'Field is Required',
            ],
            hintText : null,
            downPaymentHintText : null,
            installmentHintText : null,
            dialog: false,
            addNewAccountValid: false,
            itemsForLoan: [],
            itemsEditForLoan: [],
            currentFirm: '',
            bankNameForLoan: '',
            accountCategoryForLoan: '',
            accountHolderName: '',
            accholderdisabled: false,
            accountTypeForLoan: '',
            accountnumberForLoan: '',
            ifsccode: '',
            datepicker1: false,
            accountLocation: '',
            accountOpeningDate: '',
            initialamount: 0,
            IFSC_Rules: [
              v => {
                  // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
                  let reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
                  return (
                    v == undefined ||
                    /^$/.test(v) ||
                    reg.test(v) ||
                    "IFSC must be Valid"
                  );
                }
            ],
            currentAccountCategoryForLoan: [
                'Firm A/C',
                'Prop A/C',
                'Normal A/C',        
            ],
            currentBankName:[
              'Allahabad Bank',
              'Andhra Bank',
              'Axis Bank',
              'Bandhan Bank',
              'Bank of India',
              'Bank Of Baroda',
              'Bank Of Maharastra',
              'Canara Bank',
              'Central Bank Of India',
              'Corporation Bank',
              'Dena Bank',
              'DCB bank',
              'HDFC bank',
              'ICICI Bank',
              'Indian Overseas Bank',
              'Kotak Mahindra Bank',
              'Oriental Bank Of Commerce',
              'Punjab National Bank',
              'Punjab and Sind Bank',
              'State Bank Of India',
              'UCO Bank',
              'Union Bank Of India',
              'Vijaya Bank',
              'Yes Bank',
            ],
            currentAccountType:[
              'Loan A/C',
            ],
            // open asset table dialog
            openAssetTable: false,
            assetdatepicker: false,

            isOpeningBalance : null,
            firmAsset : [],
            selectedFirmOpeningBalance : 0,

            assetInvoiceDate: null,
            selectedFirmFromAsset: this.firmsByBrand[0],

            // when asset age is new: account id from which money will be deducted
            selectAccountFromAsset: null,

            selectAsset:null,
            assetRemark:null,

            operationPaymentType: null,
            amountFromCash: null,
            amountFromBank: null,
            addError: null,

            addition: null,
            additionAmount: null,
            deletionAmount: null,
            operationAccountForTransaction: null,
            operationAmountFromCash: null,
            operationAmountFromBank: null,

            asset: {
                totalAmount:null,
            },
            
            GST_types_list:['CGST|SGST', 'IGST'],
            isGSTApplicable:null,
            taxableGST_rate:null,
            GST_type : null,
            // isRCMApplicable : null,
            taxableAmount : null,
        }
    },
    computed: {
        ...mapGlobalGetters(["brandFinYear"]),
        getOperationOptions() {
            return this.asset.age === false && this.asset.isVerified ? [
                    { text: 'Addition', value: 'addition'},
                    {text: 'Deletion', value: 'deletion'},
                    {text: 'No Operation', value: 'noOp'}
                ] : [
                    { text: 'Addition', value: 'addition'},
                    {text: 'Deletion', value: 'deletion'},
                    {text: 'No Operation', value: 'noOp'}
                ]
        },
        assetTypeList() { return ASSET_TYPE_WITH_DEPRICIATION},
        assetCategoryList() { return ASSET_CATEGORY },
        assetPurchaseType() { return ASSET_PURCHASE_TYPE },
        paymentOptions() { return PAYMENT_OPTIONS },
        financialYear() { return getFinancialYear() },
        isAssetPurchaedInfinancialYear() {
            if(this.selectAsset && this.assetPurchaseDate && this.selectedAssetDetail.isVerified) {
                return this.financialYear.includes(this.assetPurchaseDate.split('-')[0])
            }
            return false
        },
        accountsByFirm() {
            if(this.selectedFirmFromAsset) {
                // return this.accountsByBrand.filter(item => item.account.firm === this.selectedFirmFromAsset)
                // return this.accountsByBrand.filter(item => item.account.firm === (this.selectedFirmFromAsset.value || this.selectedFirmFromAsset.value ))
                return this.accountsByBrand.filter(item => item.account.firm === this.selectedFirmFromAsset.value)
            }
            return []
        },
        otherAccountByBrand() {
            return this.accountsByFirm.filter(account => account.account.accountType !== 'Loan A/C')
        },
        loanAccountByBrand() {
            return this.accountsByFirm.filter(account => account.account.accountType === 'Loan A/C')
        },
        allowDepriciation() {
            const list = this.assetTypeList.find(item => item.value === this.asset.type)
            if(list) {
                return !!list.depriciation
            }
            return false
        },
        depriciationList() {
            const list = this.assetTypeList.find(item => item.value === this.asset.type)
            if(list && list.depriciation !== false) {
                return list.depriciation
            }
            return []
        },
        selectedAssetDetail() {
            const asset = this.assetByBrand.find(asset => asset['value'] === this.selectAsset)
            if(asset) {
                this.asset = asset.asset
                return asset.asset
            }
            return null;
        },
        assetEditDisabled() {
            if(this.selectedAssetDetail) {
                return !!this.selectedAssetDetail.isVerified
            }
            return false;
        },
        selectedFirmDetailToPay() {
            if(this.selectedFirmFromAsset) {
                return this.firmsByBrand.find(item => item.value === this.selectedFirmFromAsset.value).firm;
            }
            return null
        },
        selectedBankAccountDetailToPay() {
            if(this.selectAccountFromAsset) {
                return this.accountsByBrand.find(item => item.value === this.selectAccountFromAsset).account;
            }
            return null
        }
    },
    created() {
        // this.$bindAsObject('firmById', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
        this.$bindAsObject('bankById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand))
        this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand))
        this.$bindAsObject("assetOfBrand", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("assetList", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
        // this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
        let today = new Date()
        this.assetInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    },
    
    watch: {
            "selectedFirmFromAsset": {
                handler(newVal, oldVal) {
                    this.currentFirm = newVal;
                    if(newVal != oldVal) {
                    this.getFirmAsset();
                    }
                },
                deep: true
            },
            "selectAsset": {
                handler(newVal, oldVal) {
                    if(newVal != oldVal) {
                    this.getFirmAsset();
                    }
                },
                deep: true
            },
            "asset.totalAmount" : {
                handler(){
                    this.hintText = this.asset.totalAmount ? _.startCase(digitsToWords(Number.parseFloat(this.asset.totalAmount))) : null
                },
                deep : true
            },
            "asset.downPaymentAmount" : {
                handler(){
                    this.downPaymentHintText = this.asset.downPaymentAmount ? _.startCase(digitsToWords(Number.parseFloat(this.asset.downPaymentAmount))) : null
                },
                deep : true
            },
            "asset.installmentAmount" : {
                handler(){
                    this.installmentHintText = this.asset.installmentAmount ? _.startCase(digitsToWords(Number.parseFloat(this.asset.installmentAmount))) : null
                },
                deep : true
            },
    },
    methods: {
            getFirmbyId(id){
                // return this.firms.filter(item => item['.key'] == id)[0].name
                return this.firmsByBrand.finc(item => item['value'] == id).name
            },
            propbyId(id){
                // return this.firmsByBrand.finc(item => item['value'] == id).proprietor
                return this.firms.filter(item => item['.key'] == id)[0].proprietor
            },
            cancelDialog(){
              this.dialog = false;
              if(this.$refs.addAccount) {
                this.$refs.addAccount.reset();
                this.currentFirm = this.selectedFirmFromAsset;
              }
            },
            categoryChange(){
                var self = this;
                setTimeout(function(){
                    if(self.accountCategoryForLoan=="Firm A/C" &&  self.selectedFirmFromAsset){
                      self.accountHolderName=self.getFirmbyId(self.selectedFirmFromAsset)
                      self.accholderdisabled=true
                    }else if(self.accountCategoryForLoan=="Prop A/C" &&  self.selectedFirmFromAsset){
                      self.accountHolderName=self.propbyId(self.selectedFirmFromAsset)
                      self.accholderdisabled=true;
                    }else{
                      self.accountHolderName=""
                      self.accholderdisabled=false;
                    }
                },1000)
            },
            
            getFirms () {
                this.dialog =true;
            },
            
            addNewAccount () {
            if(!this.$refs.addAccount.validate()) {
              return console.info('not vlaid....')
            }
            let data ={
              brand:this.selectedBrand,
              brandFinYear : this.brandFinYear,
              firm:this.currentFirm,
              bankName:this.bankNameForLoan,
              accountCategory:this.accountCategoryForLoan,
              accountHolderName:this.accountHolderName,
              accountnumber:this.accountnumberForLoan,
              ifsccode:this.ifsccode,
              accountLocation:this.accountLocation,
              accountType:this.accountTypeForLoan,
              amount:Number(this.initialamount),
              openingDate : new Date(this.accountOpeningDate).toISOString().substr(0, 10),
            //   openingBalance:Number(this.openingBalance),
            }

            this.$root.$firebaseRefs.account.push(data, () => {
            this.clearForm()
            this.cancelDialog();
            });
        },
        clearForm() {
            this.dialog=false;
            this.bankNameForLoan="";
            this.accountCategoryForLoan="";
            this.ifsccode=null;
            this.accountHolderName=null;
            this.accountTypeForLoan="";
            this.accountLocation=null;
            this.accountnumberForLoan="";
            this.amount=0;
            this.accountOpeningDate = null;
            this.initialamount = 0;
        },

        getFirmAsset(){
            // this.selectedFirm = this.firmsByBrand.filter(item => item['value'] == this.selectedFirmFromAsset)[0]
            this.selectedFirm = this.selectedFirmFromAsset.firm;
            console.log(this.selectedFirm)
            let firmAsset = this.invoices.filter(item => (item["firm"] === this.selectedFirmFromAsset.value && 
            item['assetType'] === this.selectAsset
             && item['brand'] === this.selectedBrand
            ))
            this.firmAsset = firmAsset;
            let openingBalance = 0;
            firmAsset.map((inv)=>{
                openingBalance = (inv.assetInfo.openingBalance ? parseInt(inv.assetInfo.openingBalance) : 0);
            });
            this.selectedFirmOpeningBalance = openingBalance;
        },
        // Income Functionality
        assetAmountClick: async function(e) {
            if(!this.selectedFirmFromAsset) {
                return this.$emit('notify', 'select firm')
            }
            if(!this.selectAsset) {
                return this.$emit('notify', 'Please enter Asset Source')
            }
            const asset = {
                category: this.asset.category,
                type: this.asset.type,
                asset: this.asset.asset,
                brand: this.selectedBrand,
            }
            if(!asset.category) {
                return this.$emit('notify', 'Please select category')
            }
            if(!asset.type) {
                return this.$emit('notify', 'Please select asset type')
            }
            if(this.allowDepriciation) {
                if(!this.asset.depriciation) {
                    return this.$emit('notify', 'Select Depriciation for asset')
                }
                asset.depriciation = this.asset.depriciation
            }
            if(this.asset.age) {
                if(!this.asset.totalAmount) {
                    return this.$emit('notify', 'Please add asset Purchase amount');
                }
                if(!this.asset.purchaseType) {
                    return this.$emit('notify', 'Please select asset Purchase type');
                }
                // check is it possible to deduct money from account and purchase type
                asset.totalAmount = Number(this.asset.totalAmount)
                asset.totalAdditionAmount = asset.totalAmount;
                asset.purchaseType = this.asset.purchaseType
                try {
                    // get info for purchase type of asset
                    let purchaseAmountError = false
                    switch(this.asset.purchaseType) {
                        // Downpayment
                        case this.assetPurchaseType[0].value:
                            asset.downPaymentAmount = Number(this.asset.totalAmount)
                            break;
                        // Partial
                        case this.assetPurchaseType[1].value:
                            if(asset.totalAmount !== Number(this.asset.downPaymentAmount) + Number(this.asset.installmentAmount)) {
                                purchaseAmountError = 'total of downpayment and EMI amount should be equal to total Amount';
                            }
                            asset.downPaymentAmount = Number(this.asset.downPaymentAmount);
                            asset.installmentAmount = Number(this.asset.installmentAmount);
                            if(!this.asset.loanAccount) {
                                purchaseAmountError = 'Select loan account to pay EMI'
                            } else {
                                let loanAccounBalance = this.asset.loanAccount ? this.bankById[this.asset.loanAccount].amount : 0;
                                if(asset.installmentAmount > loanAccounBalance) {
                                    purchaseAmountError = 'Insufficient balance in loan account'
                                }
                            }
                            break;
                        // EMI
                        case this.assetPurchaseType[2].value:
                            asset.installmentAmount = Number(this.asset.totalAmount)
                            if(!this.asset.loanAccount) {
                                purchaseAmountError = 'Select loan account to pay EMI'
                            } else {
                                let loanAccounBalance = this.asset.loanAccount ? this.bankById[this.asset.loanAccount].amount : 0;
                                if(asset.installmentAmount > loanAccounBalance) {
                                    purchaseAmountError = 'Insufficient balance in loan account'
                                }
                            }
                            break;
                    }
                    if(purchaseAmountError) {
                        return this.$emit('notify', purchaseAmountError);
                    }
                    // get info asset payment information
                    let paymentMethodError = false;
                    // asset information added by user is valid check for validation for amount calculation
                    let firmBalance = this.selectedFirmFromAsset.firm.amount || 0;
                    //let firmBalance = this.firmById[this.selectedFirmFromAsset].amount || 0;
                    let accountBalance = this.selectAccountFromAsset ? this.bankById[this.selectAccountFromAsset].amount : 0;
                    if(!this.asset.purchaseType) {
                        return this.$emit('notify', 'select asset purchase method');
                    }
                    switch(this.asset.paymentType) {
                        // cash
                        case this.paymentOptions[0].value:
                            if(asset.downPaymentAmount >= firmBalance) {
                                paymentMethodError = `Insufficient balance in firm ${firmBalance}`
                            }
                            break;
                        // bank
                        case this.paymentOptions[1].value:
                            if(!this.selectAccountFromAsset) {
                                paymentMethodError = 'Select bank account to pay';
                                break;
                            }
                            if(asset.downPaymentAmount >= accountBalance) {
                                // Insufficient balance in bank account
                                paymentMethodError = `Insufficient balance in bank Account ${accountBalance} to pay downpayment`
                                break;
                            }
                            break;
                        // cash & bank
                        case this.paymentOptions[2].value:
                            if(!this.asset.amountFromCash) {
                                paymentMethodError = 'enter amount to pay as cash'
                                break;
                            }
                            if(!this.asset.amountFromBank) {
                                paymentMethodError = 'enter amount to pay from bank'
                                break;
                            }
                            if(!this.selectAccountFromAsset) {
                                paymentMethodError = 'Select bank account to pay';
                                break;
                            }
                            if(this.asset.amountFromBank >= accountBalance) {
                                // Insufficient balance in bank account
                                paymentMethodError = `Insufficient balance in bank Account ${accountBalance} to pay downpayment`
                                break;
                            }
                            if(this.asset.amountFromCash >= firmBalance) {
                                paymentMethodError = `Insufficient balance in firm ${firmBalance}`
                                break;
                            }
                            break;
                        default:
                            paymentMethodError = 'Select asset payment Method';
                            break;
                    }
                    // clear payment related error is purchase by EMI
                    if(this.asset.purchaseType === 'installment') {
                        paymentMethodError = false
                    }
                    if(paymentMethodError) {
                        return this.$emit('notify', paymentMethodError);
                    }
                    if(!this.assetRemark) {
                        return this.$emit('notify', 'Add Remark detail')
                    }
                } catch(e) {
                    return console.info(e)
                }
                // this.asset.openingBalance = 0;
                asset.openingBalance = Number(0)
                asset.disableOpeningBalance = true;
            }
            else {
                if(!this.asset.openingBalance && !this.asset.totalAmount) {
                    return this.$emit('notify', 'Enter Asset opening Balance');
                } else {
                    if(this.selectedFirmOpeningBalance) {
                        asset.openingBalance = this.asset.openingBalance;
                        asset.invoiceOpeningBalance = 0;
                    } else {
                        if(asset.age) {
                            asset.openingBalance = 0;
                            asset.invoiceOpeningBalance = 0;
                        } else {
                            const assetGet = this.assetOfBrand[this.selectAsset]
                            if(assetGet && assetGet.openingBalance) {
                                asset.openingBalance = Number.parseFloat(Number.parseFloat(this.asset.openingBalance)  || 0)
                            } else {
                                asset.openingBalance = Number.parseFloat(this.asset.openingBalance || 0)
                            }
                            asset.invoiceOpeningBalance = Number.parseFloat(this.asset.openingBalance || 0)
                        }
                    }
                    asset.disableOpeningBalance = true;
                }
                if(!this.addition) {
                    return this.$emit('notify', 'Select operation type for asset');
                }
                if(this.addition !== 'noOp') {
                    if(!this.operationPaymentType) {
                        return this.$emit('notify', 'Select Payment Method type for operation')
                    }

                    if(this.addition === 'addition') {
                        if(!this.additionAmount) {
                            return this.$emit('notify', 'Add addtition amount')
                        } else {
                            asset.totalAdditionAmount = (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount)
                        }
                    }
                    if(this.addition === 'deletion') {
                        if(!this.deletionAmount) {
                            return this.$emit('notify', 'Add deletion amount')
                        } else {
                            asset.totalDeletionAmount = (this.asset.totalDeletionAmount || 0) + Number(this.deletionAmount)
                        }
                        const maxDeletionAmount = Number(this.asset.openingBalance) + Number(this.asset.totalAdditionAmount) - Number(this.asset.totalDeletionAmount) 
                        if(this.deletionAmount > maxDeletionAmount) {
                            return this.$emit('notify', `Max Deletion amont allowed is ${maxDeletionAmount}/-`)
                        }
                    }
                    if(this.operationPaymentType === 'CashAndBank Account' && (!this.operationAmountFromCash || !this.operationAmountFromBank)) {
                        return this.$emit('notify', 'Enter amount to pay from bank and cash for operation')
                    }
                    if(this.operationPaymentType !== 'Cash' && !this.operationAccountForTransaction) {
                        return this.$emit('notify', 'Select Bank account for operation')
                    }
                }
                if(!this.assetRemark) {
                    return this.$emit('notify', 'Add Remark detail')
                }
                let transactionError = false;
                if(this.addition === 'addition') {
                    //const firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
                    const firmBalance = this.selectedFirmFromAsset.firm.amount;
                    const accountBalance = this.operationAccountForTransaction ? this.bankById[this.operationAccountForTransaction].amount : 0;
                    switch(this.operationPaymentType) {
                        case 'Cash':
                            if(this.additionAmount > firmBalance) {
                                transactionError = `Insufficiant balance in firm ${firmBalance}`;
                                break;
                            }
                            break;
                        case "Bank Account":
                            if(this.additionAmount > accountBalance) {
                                // Insufficient balance in bank account
                                transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`
                                break;
                            }
                            break;
                        case "CashAndBank Account":
                            if(Number(this.additionAmount) !== Number(this.operationAmountFromCash) + Number(this.operationAmountFromBank)) {
                                transactionError = 'Total of by cash and bank amount should be same as operation Amount!';
                                break;
                            }
                            if(this.operationAmountFromCash > firmBalance) {
                                transactionError = `Insufficiant balance in firm ${firmBalance}`;
                                break;
                            }
                            if(this.operationAmountFromBank > accountBalance) {
                                // Insufficient balance in bank account
                                transactionError = `Insufficient balance in bank Account ${accountBalance} to pay`
                                break;
                            }
                            break;
                    }
                }
                if(transactionError) {
                    return this.$emit('notify', transactionError);
                }
            }

            const assetToUpdate = {
                ...this.selectedAssetDetail,
                ...asset,
            }
            delete assetToUpdate['.key'];

            // create a invoice data now
            const invoiceData = {
                firm: this.selectedFirmFromAsset.value,
                brand: this.selectedBrand,
                brandFinYear : this.brandFinYear,
                type:'automatic invoice',
                remark: this.assetRemark,

                // assetId and assetInfo
                assetType: this.selectAsset,
            }
            invoiceData.assetInfo = assetToUpdate
            if(this.asset.age) {   
                invoiceData.paymentType = this.asset.paymentType;
                invoiceData.isCredited = false;
                switch(invoiceData.paymentType) {
                    case "Cash":
                        invoiceData.totalAmount = assetToUpdate.totalAmount;
                        invoiceData.amountFromCash = Number(assetToUpdate.totalAmount);
                        break;                   
                    case "Bank Account":
                        invoiceData.totalAmount = assetToUpdate.totalAmount;
                        invoiceData.amountFromBank = invoiceData.totalAmount;
                        invoiceData.bank = this.selectAccountFromAsset;
                        break;
                    case "CashAndBank Account":
                        invoiceData.bank = this.selectAccountFromAsset
                        invoiceData.totalAmount = assetToUpdate.totalAmount
                        invoiceData.amountFromBank = Number(this.asset.amountFromBank)
                        invoiceData.amountFromCash = Number(this.asset.amountFromCash)
                        break;
                }
                if(this.asset.purchaseType === 'partial') {
                    
                    invoiceData.loanAccount = this.asset.loanAccount
                    invoiceData.installmentAmount = Number(this.asset.installmentAmount);
                    invoiceData.downPaymentAmount = Number(this.asset.downPaymentAmount);
                }
                if(this.asset.purchaseType === 'installment') {
                    invoiceData.bank = this.asset.loanAccount;
                    invoiceData.totalAmount = invoiceData.installmentAmount;
                    invoiceData.loanAccount = this.asset.loanAccount
                    invoiceData.installmentAmount = Number(this.asset.totalAmount)
                }
                if(this.asset.purchaseType === 'downpayment') {
                    invoiceData.downPaymentAmount = Number(this.asset.totalAmount)
                }
            } else {
                if(this.addition !== 'noOp') {
                    invoiceData.paymentType = this.operationPaymentType
                    if(this.addition === 'addition') {
                        // deduct money
                        invoiceData.isCredited = false;
                        invoiceData.totalAmount = Number(this.additionAmount)
                    } else {
                        // credit money
                        invoiceData.isCredited = true;
                        invoiceData.totalAmount = Number(this.deletionAmount)
                    }
                    switch(invoiceData.paymentType) {
                        case "Cash":
                            invoiceData.amountFromCash = invoiceData.totalAmount;
                            break;                   
                        case "Bank Account":
                            invoiceData.amountFromBank = invoiceData.totalAmount;
                            invoiceData.bank = this.operationAccountForTransaction
                            break;
                        case "CashAndBank Account":
                            invoiceData.bank = this.operationAccountForTransaction
                            invoiceData.amountFromBank = Number(this.operationAmountFromBank)
                            invoiceData.amountFromCash = Number(this.operationAmountFromCash)
                        break;
                    }
                }
            }

            // update asset flag with age as false and isVerfied as true
            assetToUpdate.age = false;
            assetToUpdate.isVerified = true;

            this.$root.$firebaseRefs.assets.child(this.selectAsset).update(assetToUpdate, () => {
                if(this.addition === 'noOp') {
                    invoiceData.totalAmount = 0;
                    this.generateInvoice(invoiceData);
                }
                // if cash or cashAndBank
                if(invoiceData.amountFromCash) {
                    const invoice = {...invoiceData}
                        if(invoice.paymentType == "CashAndBank Account") {
                            invoice.totalAmount = invoice.amountFromCash;
                        } else {
                            invoice.totalAmount = invoice.downPaymentAmount ? invoice.downPaymentAmount : invoice.amountFromCash;
                        }
                    invoice.paymentType = "Cash";
                    // invoice.totalAmount = invoice.amountFromCash;
                    delete invoice.amountFromCash;
                    delete invoice.amountFromBank
                    delete invoice.loanAccount;
                    delete invoice.installmentAmount;
                    delete invoice.downPaymentAmount;
                    delete invoice.bank;
                    this.generateInvoice(invoice);
                }
                // if bank or cashAndBank
                if(invoiceData.amountFromBank) {
                    const invoice = {...invoiceData}
                    if(invoice.paymentType == "CashAndBank Account") {
                        invoice.totalAmount = invoice.amountFromBank;
                    } else {
                        invoice.totalAmount = invoice.downPaymentAmount ? invoice.downPaymentAmount : invoice.amountFromBank;
                    }
                    invoice.paymentType = "Bank Account";
                    // invoice.totalAmount = invoice.amountFromBank;
                    delete invoice.amountFromCash;
                    delete invoice.amountFromBank
                    delete invoice.loanAccount;
                    delete invoice.installmentAmount;
                    delete invoice.downPaymentAmount;
                    this.generateInvoice(invoice);
                }
                // if paid by EMI
                if(invoiceData.installmentAmount) {
                    const invoice = {...invoiceData}
                    invoice.totalAmount = invoice.installmentAmount;
                    invoice.bank = invoice.loanAccount;
                    invoice.paymentType = "Bank Account";
                    delete invoice.amountFromCash;
                    delete invoice.amountFromBank
                    delete invoice.loanAccount;
                    delete invoice.installmentAmount;
                    delete invoice.downPaymentAmount;
                    this.generateInvoice(invoice);
                }
            });
        },
        generateInvoice: function(invoiceData) {
            invoiceData.type = 'automatic invoice',
            invoiceData.transactionType = 'Asset',
            invoiceData.date = this.assetInvoiceDate ? Date.parse(this.assetInvoiceDate) : Date.now()
            // add account Number of bank account in invoice
            if(invoiceData.bank) {
                invoiceData.accountNumber = this.bankById[invoiceData.bank].accountnumber;
            }
            try {
                invoiceData['openingBalance'] = this.asset.invoiceOpeningBalance ? Number.parseFloat(this.asset.invoiceOpeningBalance) : 0;
                if(this.isGSTApplicable) {
                    invoiceData['isGSTApplicable'] = this.isGSTApplicable;
                }

                if(this.taxableGST_rate) {
                    invoiceData['taxableGST_rate'] = this.taxableGST_rate;
                }

                if(this.GST_type) {
                    invoiceData['GST_type'] = this.GST_type;
                }

                // if(this.isRCMApplicable) {
                //     invoiceViaCash['isRCMApplicable'] = this.isRCMApplicable;
                // }

                if(this.taxableAmount) {
                    invoiceData['taxableAmount'] = this.taxableAmount;
                }
                this.$root.$firebaseRefs.invoice.push(invoiceData, () => {
                    this.managePayments(invoiceData);
                });
            } catch(e) {
                console.error(invoiceData, e)
                this.$emit('notify', 'Error while generating Invoice...!')
            }
        },  
        addAsset: function(e) {
            let availableAsset = this.assetList.filter(item => item.asset ==  e.target.value && item['brand'] === this.selectedBrand);
            if(availableAsset.length) {
                this.addError = 'Asset with name ' + e.target.value + ' Already exist.';
                setTimeout(() => {
                    this.addError = null;
                }, 3000);
            } else {
                let assetData = {
                    brand: this.selectedBrand,
                    asset: e.target.value,
                    age: true,
                    isVerified: false,
                    disableOpeningBalance: false,
                    totalAdditionAmount: 0,
                    totalDeletionAmount: 0,
                    createdAt: Date.now(),
                }
                this.$root.$firebaseRefs.assets.push(assetData);
            }
            /**
             * Create asset with 
             * asset: name of asset
             * brand: brandID of customer
             * isVerified: falg to decide is asset has all detail or not
             * age: set age asset as new for default
             * totalAdditionAmount : 0
             * totalDeletionAmount: 0
             */
           
        }, 
        reset(close = true) {
            this.selectedFirmFromAsset = this.firmsByBrand[0];
            this.selectAccountFromAsset = null;
            this.selectAsset = null;
            this.assetRemark =null;
            this.operationPaymentType = null;
            this.amountFromCash = null;
            this.amountFromBank = null;
            this.addition = null;
            this.additionAmount = null;
            this.deletionAmount = null;
            this.operationAccountForTransaction = null;
            this.operationAmountFromCash = null;
            this.operationAmountFromBank = null;
            let today = new Date()
            this.assetInvoiceDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`;
            this.asset = {};
            if(close) {
                this.$emit('closeDialog');
            }
        },
        /**
         * @param {Object} invoiceData
         * @param {String} invoiceData.firm firmId
         * @param {String} invoiceData.paymentType type of payment method
         * @param {String} invoiceData.bank bankId
         * @param {Number} invoiceData.totalAmount totalAmount of invoice
         * @param {Number} invoiceData.amountFromBank money to deduct from bank
         * @param {Number} invoiceData.amountFromCash money to deduct dfrom firm
         */
        managePayments(invoiceData){
            // let firm = this.firmById[invoiceData.firm]
            let firm = this.firmsByBrand.find(item => item.value == invoiceData.firm).firm;
            let bank = this.bankById[invoiceData.bank]
            let loanBank = null
            if(invoiceData.loanAccount) {
               loanBank = this.bankById[invoiceData.loanAccount]
            }
            /*
            NOT USED ANYMORE: EMI Will generate invoice as BANK ACCOUNT
            if(invoiceData.loanAccount) {
                // deduct loan amount from 
                let loan = this.bankById[invoiceData.loanAccount]
                loan.amount = loan && loan.amount - invoiceData.installmentAmount;
                this.$root.$firebaseRefs.account.child(invoiceData.loanAccount).set(loan)
            }
            */
           try {
               switch(invoiceData.paymentType) {
                   case 'Cash' : {
                       if(this.asset.age && this.asset.purchaseType) {
                            if(this.asset.purchaseType === 'partial' && loanBank) {
                                firm.amount = firm && firm.amount - invoiceData.downPaymentAmount;
                                loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                            } else if(this.asset.purchaseType === 'installment' && loanBank) {
                                loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                            } else if(this.asset.purchaseType === 'downpayment') {
                                firm.amount = firm && firm.amount - invoiceData.totalAmount;
                            } else {
                                if(invoiceData.isCredited) {
                                    firm.amount = firm && firm.amount + invoiceData.totalAmount;
                                } else {
                                    firm.amount = firm && firm.amount - invoiceData.totalAmount;
                                }
                            }
                       } else {
                            if(invoiceData.isCredited) {
                                firm.amount = firm && firm.amount + invoiceData.totalAmount;
                            } else {
                                firm.amount = firm && firm.amount - invoiceData.totalAmount;
                            }
                       }
                        if(loanBank){
                            this.$root.$firebaseRefs.account.child(invoiceData.loanBank).set(loanBank);
                        }
                        delete firm['.key']
                        this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm)
                       break;
                   }
                   case 'Bank Account' : {
                       if(this.asset.age && this.asset.purchaseType) {
                            if(this.asset.purchaseType === 'partial' && loanBank) {
                                bank.amount = bank && bank.amount - invoiceData.downPaymentAmount;
                                loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                            } else if(this.asset.purchaseType === 'installment' && loanBank) {
                                loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                            } else if(this.asset.purchaseType === 'downpayment') {
                                bank.amount = bank && bank.amount - invoiceData.totalAmount;
                            } else {
                                if(invoiceData.isCredited) {
                                    bank.amount = bank && bank.amount + invoiceData.totalAmount;
                                } else {
                                    bank.amount = bank && bank.amount - invoiceData.totalAmount;
                                }
                            }
                       } else {
                            if(invoiceData.isCredited) {
                                bank.amount = bank && bank.amount + invoiceData.totalAmount;
                            } else {
                                bank.amount = bank && bank.amount - invoiceData.totalAmount;
                            }
                       }
                        if(loanBank){
                            this.$root.$firebaseRefs.account.child(invoiceData.loanBank).set(loanBank);
                        }
                        this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
                       break;
                   }
                   // not used as cashAndBank will create two seperate invoice
                   case 'CashAndBank Account' : {
                       if(this.asset.age && this.asset.purchaseType) {
                            if(this.asset.purchaseType === 'partial' && loanBank) {
                                bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                                loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                            } else if(this.asset.purchaseType === 'installment' && loanBank) {
                                loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                            } else if(this.asset.purchaseType === 'downpayment') {
                                bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                            } else {
                                if(invoiceData.isCredited) {
                                    bank.amount = bank && bank.amount + invoiceData.amountFromBank;
                                    firm.amount = firm && firm.amount + invoiceData.amountFromCash;
                                } else {
                                    bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                    firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                                }
                            }
                       } else {
                            if(invoiceData.isCredited) {
                                bank.amount = bank && bank.amount + invoiceData.amountFromBank;
                                firm.amount = firm && firm.amount + invoiceData.amountFromCash;
                            } else {
                                bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                            }
                       }
                       delete firm['.key']
                       this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
                       this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
                       if(loanBank){
                            this.$root.$firebaseRefs.account.child(invoiceData.loanBank).set(loanBank);
                        }
                       break;
                   }
               }
               // close modal
               this.$emit('notify', "Invoice Created for Asset", true);
               this.reset(true);
           } catch(e) {
               console.error(invoiceData, e)
               this.$emit('notify', 'Error Occured while calulating money...!')
           }

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/tabs/asset.vue